<template>
  <div class="score-gauge" ref="div">
    <div class="value" :style="valueStyle">{{Math.round(value)}}</div>
    <radial-gauge ref="gauge" class="gauge" :value="parseFloat(value)" :options="options"></radial-gauge>
  </div>
</template>

<style scoped>
div.score-gauge {
  display: inline-flex;
  position: relative;
  width: 100%;
}
.gauge {
    margin-left: auto;
    margin-right: auto;
}
div.value {
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: 0;
  font-weight: 500;
}
</style>

<script>
import RadialGauge from "vue2-canvas-gauges/src/RadialGauge";

export default {
  props: ["value", "trendMin", "trendMax", "trendAverage", "color", "size"],
  computed: {
    options() {
      const highlights = [];
      if (typeof this.$props.trendMin != 'undefined' && typeof this.$props.trendMax != 'undefined') {
        highlights.push({
          from: this.$props.trendMin,
          to: this.$props.trendMax,
          color: "#ccc"
        });
      }
      if (this.$props.trendAverage) {
        highlights.push({
          from: parseFloat(this.$props.trendAverage) - 1,
          to: parseFloat(this.$props.trendAverage) + 1,
          color: "#888"
        });
      }
      return {
        width: this.$props.size || 200,
        height: this.$props.size || 200,
        colorPlate: "transparent",
        colorBar: "#eee",
        colorBarProgress: this.$props.color,
        colorNeedle: this.$props.color,
        colorNumbers: "transparent",
        colorNeedleEnd: this.$props.color,
        colorMajorTicks: this.$props.size <= 50 ? "transparent" : "rgba(0,0,0,0.1)",
        colorMinorTicks: this.$props.size <= 50 ? "transparent" : "rgba(0.5,0.5,0.5,0.1)",
        startAngle: 45,
        ticksAngle: 270,
        minValue: 0,
        maxValue: 100,
        strokeTicks: false,
        minorTicks: 0,
        majorTicks: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        borderShadowWidth: 0,
        borders: false,
        needleType: "line",
        needleShadow: false,
        needleWidth: this.$props.value > 0.01 && this.$props.value < 99.9 ? 5 : 0,
        needleStart: 40,
        needleEnd: 95,
        needleCircleOuter: false,
        needleCircleInner: false,
        barWidth: 20,
        valueBox: false,
        barBeginCircle: 0,
        tickSide: "both",
        highlights
      };
    },
    valueStyle() {
      return {
          'color': this.$props.color,
          'font-size': `${(this.$props.size <= 50 ? this.$props.size/3 : this.$props.size/4) || 50}px`,
          'margin-bottom': `${(this.$props.size <= 50 ? this.$props.size/4 : this.$props.size/3) || 50}px`
        };
    },
  },
  components: {
    RadialGauge
  }
};
</script>
